import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import GooglePayCheckoutForm from "./GooglePayScreen";

const PaymentOptions = () => {
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const loadStripeAsync = async () => {
      const stripe = await loadStripe(
        "pk_test_51NhHNZFDxlsdZq5eQisMgNxM7vDvVG9SO0Le60jOpQa6KwSxbu9xiP9D8B5oyUQrbn25bu6SBlNhedgMWgSkwaDq00KXlVG4TR"
      );
      setStripePromise(stripe);
    };

    loadStripeAsync();
  }, []);

  return (
    <div className="w-full flex flex-col text-center px-[2rem] pb-8 gap-4">
      {stripePromise && (
        <Elements stripe={stripePromise}>
          <GooglePayCheckoutForm amount={20} /> {/* Set amount for testing */}
        </Elements>
      )}
    </div>
  );
};

export default PaymentOptions;